import script from "./WalkthroughSimulate.vue?vue&type=script&setup=true&lang=ts"
export * from "./WalkthroughSimulate.vue?vue&type=script&setup=true&lang=ts"

import "./WalkthroughSimulate.vue?vue&type=style&index=0&id=84380b74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84380b74"]])

export default __exports__